import { ActivatedRouteSnapshot, BaseRouteReuseStrategy } from '@angular/router';

/**
 * Null-safe override of Angular's DefaultRouteReuseStrategy.
 *
 * Angular Router ≥21.2.8 can pass undefined snapshots to shouldReuseRoute
 * during redirect resolution, causing "Cannot read properties of undefined
 * (reading 'routeConfig')". This adds optional chaining to prevent the crash.
 *
 * Remove once Angular ships a fix upstream.
 */
export class SafeRouteReuseStrategy extends BaseRouteReuseStrategy {
  override shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    return future?.routeConfig === curr?.routeConfig;
  }
}
